/**
 * Shared time period utilities for the entity metrics dashboard tabs.
 */
import { DateTime } from 'luxon';

export const TIME_PERIOD_VALUES = ['1d', '7d', '30d', '3m', '6m', '12m'] as const;
export type TimePeriodValue = (typeof TIME_PERIOD_VALUES)[number];

/** Convert a time period value to a [startDate, endDate] tuple */
export const getDateRange = (period: TimePeriodValue): [string, string] => {
  const end =
    DateTime.now().toISODate() ?? DateTime.now().toFormat('yyyy-MM-dd');
  let start: string;
  switch (period) {
    case '1d':
      start = DateTime.now().startOf('day').toISODate() ?? end;
      break;
    case '7d':
      start = DateTime.now().minus({ days: 7 }).toISODate() ?? end;
      break;
    case '30d':
      start = DateTime.now().minus({ days: 30 }).toISODate() ?? end;
      break;
    case '3m':
      start = DateTime.now().minus({ months: 3 }).toISODate() ?? end;
      break;
    case '6m':
      start = DateTime.now().minus({ months: 6 }).toISODate() ?? end;
      break;
    case '12m':
      start = DateTime.now().minus({ months: 12 }).toISODate() ?? end;
      break;
    default:
      start = DateTime.now().minus({ months: 6 }).toISODate() ?? end;
  }
  return [start, end];
};

/** i18n key for each time period value */
export const TIME_PERIOD_KEYS: Record<TimePeriodValue, string> = {
  '1d': 'period_today',
  '7d': 'period_last_7_days',
  '30d': 'period_last_30_days',
  '3m': 'period_last_3_months',
  '6m': 'period_last_6_months',
  '12m': 'period_last_12_months',
};
